import "core-js/modules/es.array.push.js";
export default {
  data() {
    return {};
  },
  props: ['childExhibitions', 'formData', 'language'],
  methods: {
    toAudioList(item) {
      this.$router.push(`/audios?fid=${this.$route.query.fid}&exhibCode=${item.code}${this.language ? '&language=en' : ''}`);
    }
  },
  created() {
    console.log(this.childExhibitions);
  },
  computed: {}
};